import { render } from "./ResponsiveNavLink.vue?vue&type=template&id=5be3ec3e"
import script from "./ResponsiveNavLink.vue?vue&type=script&lang=js"
export * from "./ResponsiveNavLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__